import installationInstructions from './installationInstructions';

const a685Content = {
  installationInstructions
}

export { a685Content };
